/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';

import styles from './styles';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import {
  Button,
  IconButton,
  MenuItem,
  Menu,
  Toolbar,
  Typography,
  Breadcrumbs,
  Box,
  Tooltip,
  Badge,
  Divider,
  List,
  ListItemText,
  ListItemAvatar,
  Avatar,
} from '@mui/material';
import {
  ArrowLeft,
  ArrowRight,
  Clear,
  Close,
  Language,
  Menu as MenuIcon,
  PriorityHigh,
  Warning,
} from '@mui/icons-material';
import { history } from 'helpers/history';
import moment from 'moment';
import clsx from 'clsx';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { changeUserLanguage } from 'js/actions/prefsActions';
import { isAllowed } from 'helpers';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enUS, es } from 'date-fns/locale';
import TopbarName from './TopbarName';
const useStyles = makeStyles(styles);
import NotificationsIcon from '@mui/icons-material/Notifications';
import { getEvents } from 'js/actions/systemAlertAction';

export default function Topbar(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    mobile,
    isSidebarOpen,
    onToggleSidebar,
    className,
    handlePrevMonth,
    selectedDate,
    handleDateChange,
    currentMonth,
    year,
    handleNextMonth,
  } = props;
  const rootClassName = classNames(classes.root, className);
  const [anchorEl, setAnchorEl] = useState(null); // Para el menú de idioma
  const [anchorElEvents, setAnchorElEvents] = useState(null); // Para el menú de notificaciones
  const menuOpen = Boolean(anchorEl);
  const openNotifications = Boolean(anchorElEvents); // Renombrado para mayor claridad
  const { events } = useSelector((state) => state.systemAlert);
  const { pathname } = useLocation();
  const intl = useIntl();
  const prefLang = useSelector((state) => state.prefs.prefLang);
  const localeNav = useSelector((state) => state.prefs.locale);
  const location = useLocation();
  const [showChargeName, setShowChargeName] = useState(false);
  const user = useSelector((state) => state.user.user);
  const [responsive, setResponsive] = useState(false);
  const navigate = useNavigate();
  const corporative = location?.state?.corporative;

  const locale = localeNav === 'es-MX' ? es : enUS;

  // --- Lógica de Notificaciones ---
  useEffect(() => {
    if (user) {
      dispatch(getEvents(user?.personal_info?.id_user));
    }
  }, [user]);

  const [showMore, setShowMore] = useState(5);

  const handleIconClick = (event) => {
    setAnchorElEvents(event.currentTarget);
  };

  const handleCloseNotifications = () => {
    setAnchorElEvents(null);
  };

  const handleEvents = () => {
    navigate('/notificationDashboard');
  };

  const handleShowMore = () => {
    if (showMore < events.length) {
      setShowMore(showMore + 5);
    } else if (showMore >= events.length) {
      setShowMore(5);
    }
  };

  const iconsEvents = (lvl) => {
    switch (lvl) {
      case 1:
        return <PriorityHigh />;
      case 2:
        return <Warning />;
      case 3:
        return <Clear />;
      default:
        return null;
    }
  };

  const colorEvents = (lvl) => {
    switch (lvl) {
      case 1:
        return '#0086c0';
      case 2:
        return '#fdab3d';
      case 3:
        return '#e2445c';
      default:
        return null;
    }
  };

  const alert_prior = [
    intl.formatMessage({ id: 'app.alerts.priority.low' }),
    intl.formatMessage({ id: 'app.alerts.priority.medium' }),
    intl.formatMessage({ id: 'app.alerts.priority.high' }),
  ];

  // --- Fin Lógica de Notificaciones ---

  //Handlers
  const handleChangeLanguage = (selLang) => {
    const locale = selLang === 'es' ? 'es-MX' : 'en-US';
    moment.locale(selLang);
    localStorage.setItem('prefLang', selLang);
    localStorage.setItem('locale', locale);
    dispatch(changeUserLanguage({ prefLang: selLang, locale: locale }));
  };

  // Maneja la apertura del menú de idioma
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Maneja el cierre del menú de idioma
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const goBack = () => {
    history.back();
  };

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setShowChargeName(true);
    } else {
      setShowChargeName(false);
    }
  };

  const handleResize = () => {
    if (window.innerWidth > 1000) {
      setResponsive(true);
    } else {
      setResponsive(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    // Añade una carga inicial de notificaciones si es necesario (ej. desde una API)
    // fetchNotifications();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <div className={rootClassName}>
        <Toolbar className={classes.toolbar}>
          {!mobile ? (
            <IconButton
              className={clsx(classes.menuButton, {
                [classes.menuButton]: isSidebarOpen && !mobile,
                [classes.menuButtonOpen]: !isSidebarOpen && mobile,
              })}
              variant="text"
              onClick={onToggleSidebar}
            >
              {isSidebarOpen ? <Close /> : <MenuIcon />}
            </IconButton>
          ) : (
            <IconButton
              className={classes.menuButtonMobile}
              onClick={onToggleSidebar}
              variant="text"
            >
              {!isSidebarOpen && !mobile ? <Close /> : <MenuIcon />}
            </IconButton>
          )}
          <TopbarName />
          {location.state && (
            <>
              {(pathname.includes('dashboard') ||
                pathname.includes('corporative')) && (
                <Typography
                  className={clsx(classes.chargeName, {
                    [classes.chargeNameVisible]: showChargeName,
                  })}
                  color="#A53693"
                  fontWeight={600}
                  fontSize={20}
                >
                  {location.state.name}
                </Typography>
              )}
            </>
          )}
          {(pathname.includes('/meterDashboard/') ||
            pathname.includes('/meter/')) && (
            <>
              {location.state && (
                <Breadcrumbs
                  aria-label="breadcrumb"
                  className={clsx(classes.chargeName, {
                    [classes.chargeNameVisible]: showChargeName,
                  })}
                  separator=":"
                >
                  <Link
                    underline="hover"
                    style={{ color: '#A53693', textTransform: 'capitalize' }}
                    to={`/corporative/${location?.state?.corporative_id}`}
                  >
                    {intl.formatMessage({ id: 'app.meters.nav.meters' })}
                  </Link>
                  <Typography variant="h5">{location.state.name}</Typography>
                </Breadcrumbs>
              )}
            </>
          )}

          {(pathname.includes('/group') ||
            pathname.includes('/groupDashboard')) && (
            <>
              {location.state &&
                location.state?.meter &&
                !pathname.includes('/chargeDashboard') &&
                !pathname.includes('/dashboardSolarCharge') &&
                !pathname.includes('/charge') && (
                  <Box
                    sx={{ display: 'flex', flexDirection: 'row' }}
                    className={clsx(classes.chargeName, {
                      [classes.chargeNameVisible]: showChargeName,
                    })}
                  >
                    {isAllowed(user.permissions, ['corporative_read']) && (
                      <>
                        <Breadcrumbs
                          arial-label="breadcrumb"
                          className={classes.breadcrumb}
                          separator=":"
                        >
                          <Link
                            color="inherit"
                            to={`/corporative/${location.state.meter.corporative_id}`}
                            state={location.state.meter}
                            style={{
                              textTransform: 'capitalize',
                              color: '#A53693',
                            }}
                          >
                            {intl.formatMessage({
                              id: 'app.groups.nav.meters',
                            })}
                          </Link>
                          <Link
                            color="inherit"
                            to={`/meter/${location.state.meter.id}`}
                            state={location.state.meter}
                            style={{ color: 'gray', fontWeight: 500 }}
                          >
                            {location.state.meter
                              ? location.state.meter.name
                              : intl.formatMessage({
                                  id: 'app.groups.nav.groupLab2',
                                })}
                          </Link>
                        </Breadcrumbs>
                        <Typography
                          sx={{ fontWeight: 600, color: '#00AFEF', mx: 2 }}
                        >
                          {' '}
                          |{' '}
                        </Typography>
                      </>
                    )}

                    <Breadcrumbs
                      arial-label="breadcrumb"
                      className={classes.breadcrumb}
                      separator=":"
                    >
                      <Link
                        color="inherit"
                        to={`/meter/${location.state.meter.id}`}
                        state={location.state.meter}
                        style={{
                          textTransform: 'capitalize',
                          color: '#A53693',
                        }}
                      >
                        {intl.formatMessage({
                          id: 'app.charges.nav.groupLab2',
                        })}
                      </Link>
                      <Typography variant="h5">
                        {location.state.group.name !== undefined
                          ? location.state.group.name
                          : intl.formatMessage({
                              id: 'app.groups.nav.groupLab2',
                            })}
                      </Typography>
                    </Breadcrumbs>
                  </Box>
                )}
            </>
          )}

          {(pathname.includes('/charge') ||
            pathname.includes('/chargeDashboard') ||
            pathname.includes('/dashboardSolarCharge')) &&
            location.state &&
            location.state.meter &&
            location.state.group && (
              <>
                <Box
                  display="flex"
                  className={clsx(classes.chargeName, {
                    [classes.chargeNameVisible]: showChargeName,
                  })}
                >
                  {isAllowed(user.permissions, ['corporative_read']) && (
                    <>
                      <Breadcrumbs arial-label="breadcrumb" separator=":">
                        <Link
                          color="inherit"
                          style={{
                            textTransform: 'capitalize',
                            color: '#A53693',
                          }}
                          to={`/corporative/${
                            location?.state?.meter?.corporative_id
                              ? location?.state?.meter?.corporative_id
                              : corporative.id
                          }`}
                          state={location.state.meter}
                        >
                          {intl.formatMessage({
                            id: 'app.groups.nav.meters',
                          })}
                        </Link>
                        <Link
                          color="inherit"
                          style={{
                            color: 'gray',
                            fontWeight: 500,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                          to={`/meter/${location.state.meter.id}`}
                          state={location.state.meter}
                        >
                          {location.state.meter
                            ? location.state.meter.name
                            : intl.formatMessage({
                                id: 'app.groups.nav.groupLab2',
                              })}
                          <Typography
                            sx={{
                              fontWeight: 600,
                              color: '#00AFEF',
                              mx: 2,
                            }}
                          >
                            {' '}
                            |{' '}
                          </Typography>
                          <Link
                            color="inherit"
                            to={`/group/${location.state.group.id}`}
                            state={{
                              group: location.state.group,
                              meter: location.state.meter,
                              charge: location.state.charge,
                            }}
                            style={{
                              textTransform: 'capitalize',
                              color: '#A53693',
                            }}
                          >
                            {intl.formatMessage({
                              id: 'app.charges.nav.groupLab2',
                            })}
                          </Link>
                        </Link>
                        <Typography variant="h5">
                          {location.state.group
                            ? location.state.group.name
                            : intl.formatMessage({
                                id: 'app.groups.nav.groupLab2',
                              })}
                        </Typography>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            color: '#00AFEF',
                            mx: 2,
                          }}
                        >
                          {' '}
                          |{' '}
                        </Typography>
                        <Link
                          color="inherit"
                          to={`/group/${location.state.group.id}`}
                          state={{
                            group: location.state.group,
                            meter: location.state.meter,
                            charge: location.state.charge,
                          }}
                          style={{
                            textTransform: 'capitalize',
                            color: '#A53693',
                          }}
                        >
                          {intl.formatMessage({
                            id: 'app.reports.hourReports.chargeLbl',
                          })}
                        </Link>
                      </Breadcrumbs>
                    </>
                  )}
                </Box>
              </>
            )}

          {(pathname.includes('/charge') ||
            pathname.includes('/chargeDashboard') ||
            pathname.includes('/dashboardSolarCharge')) &&
            location.state &&
            !location.state.meter &&
            !location.state.group && (
              <>
                <Box
                  display="flex"
                  className={clsx(classes.chargeName, {
                    [classes.chargeNameVisible]: showChargeName,
                  })}
                >
                  <Breadcrumbs
                    arial-label="breadcrumb"
                    className={classes.breadcrumb}
                    separator=":"
                  >
                    <Link
                      color="inherit"
                      to={user.home_url}
                      style={{
                        textTransform: 'capitalize',
                        color: '#A53693',
                      }}
                    >
                      {intl.formatMessage({
                        id: 'app.reports.hourReports.chargeLbl',
                      })}
                    </Link>
                    <Typography variant="h5">
                      {location.state.charge
                        ? location.state.charge.name
                        : intl.formatMessage({
                            id: 'app.groups.nav.groupLab2',
                          })}
                    </Typography>
                  </Breadcrumbs>
                </Box>
              </>
            )}

          {(pathname.includes('/chargeDashboard/group/') ||
            pathname.includes('/dashboardSolarCharge/group/')) &&
            !pathname.includes('/trend') && (
              <Box
                display="flex"
                flexDirection="row"
                className={clsx(classes.dateBox, {
                  [classes.dateVisible]: showChargeName,
                })}
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <Tooltip aria-label="prev-month" title="Mes Anterior">
                  <IconButton
                    aria-label="prev-month"
                    color="secondary"
                    variant="contained"
                    size="small"
                    p={0}
                    sx={{
                      bgcolor: '#00AFEF',
                      color: 'white',
                      borderRadius: 2,
                      boxShadow: 3,
                    }}
                    onClick={handlePrevMonth}
                    disabled={false}
                  >
                    <ArrowLeft />
                  </IconButton>
                </Tooltip>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  adapterLocale={locale}
                >
                  <DatePicker
                    views={['year', 'month']}
                    value={selectedDate}
                    onChange={handleDateChange}
                    maxDate={new Date()}
                    minDate={new Date().setFullYear(
                      new Date().getFullYear() - 4
                    )}
                    sx={{
                      backgroundColor: '#00AFEF',
                      boxShadow: 3,
                      borderRadius: 2,
                      border: 'none',
                      '& input': {
                        textTransform: 'uppercase',
                        color: 'white',
                        p: 0.85,
                        fontWeight: 'bold',
                        textAlign: 'center',
                      },
                      '& button': {
                        color: 'white',
                        fontWeight: 'bold',
                      },
                      '& fieldset': {
                        border: 'none',
                      },
                    }}
                  />
                </LocalizationProvider>
                <Tooltip aria-label="next-month" title="Mes Siguiente">
                  <IconButton
                    aria-label="prev-month"
                    color="secondary"
                    variant="contained"
                    size="small"
                    p={0}
                    sx={{
                      bgcolor: '#00AFEF',
                      color: 'white',
                      borderRadius: 2,
                      boxShadow: 3,
                    }}
                    disabled={
                      currentMonth ===
                        (new Date().getMonth() + 1)
                          .toString()
                          .padStart(2, '0') && year === new Date().getFullYear()
                    }
                    onClick={handleNextMonth}
                  >
                    <ArrowRight />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
          <Typography
            className={classes.notificationsButton}
            style={{ fontWeight: 600 }}
            variant="body1"
          >
            {moment().format(mobile ? 'DD MMM YYYY' : 'DD MMMM YYYY')}
          </Typography>
          <Button
            id="language-button"
            aria-controls={menuOpen ? 'language-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={menuOpen ? 'true' : undefined}
            onClick={handleOpenMenu}
            className={classes.hamburguerIcon}
            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            <Language fontSize="small" color="action" />
            <Typography className={classes.translate}>
              {localeNav === 'es-MX' ? 'ESP' : 'ENG'}
            </Typography>
          </Button>

          {/* Menú desplegable de Idioma */}
          <Menu
            id="language-menu"
            anchorEl={anchorEl}
            open={menuOpen}
            onClose={handleCloseMenu}
            MenuListProps={{
              'aria-labelledby': 'language-button',
            }}
          >
            <MenuItem
              onClick={() => {
                handleChangeLanguage('es'); // Cambia a español
                handleCloseMenu(); // Cierra el menú
              }}
            >
              ESP
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleChangeLanguage('en'); // Cambia a inglés
                handleCloseMenu(); // Cierra el menú
              }}
            >
              ENG
            </MenuItem>
          </Menu>
          {/* Componente de Notificaciones */}
          <IconButton
            color="inherit"
            aria-label="mostrar notificaciones"
            aria-controls={openNotifications ? 'notifications-menu' : undefined} // Usa openNotifications
            aria-haspopup="true"
            onClick={handleIconClick}
            sx={{
              backgroundColor: 'rgb(0, 175, 239)',
              borderRadius: '8px',
              marginRight: '15px',
              marginLeft: '10px',
              '&:hover': {
                backgroundColor: 'rgb(0, 134, 187)',
                color: 'white',
              },
              boxShadow: '1px 1px 5px rgba(0,0,0,0.2)',
            }}
          >
            <Badge badgeContent={events.length} color="error" showZero={true}>
              {' '}
              {/* Añadido badgeContent */}
              <NotificationsIcon
                sx={{
                  color: 'white',
                }}
              />
            </Badge>
          </IconButton>
          <Menu
            id="notifications-menu"
            anchorEl={anchorElEvents}
            open={openNotifications} // Usa openNotifications
            onClose={handleCloseNotifications} // Usa handleCloseNotifications
            MenuListProps={{
              'aria-labelledby': 'icon-button',
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              py={1}
              px={2}
            >
              <Typography>{events.length} Notificaciones</Typography>
              <IconButton onClick={handleCloseNotifications}>
                <Clear />
              </IconButton>
            </Box>
            <Divider />
            {events.length === 0 ? (
              <MenuItem onClick={handleCloseNotifications}>
                <Typography variant="body2" color="text.secondary">
                  No hay notificaciones
                </Typography>
              </MenuItem>
            ) : (
              <List
                sx={{
                  width: '100%',
                  maxWidth: 360,
                  backgroundColor: 'inherit',
                  maxHeight: '400px',
                  overflowY: 'scroll',
                  bgcolor: 'inherit',
                }}
              >
                {events.slice(0, showMore).map((event) => (
                  <MenuItem key={event.id} onClick={() => handleEvents()}>
                    <ListItemAvatar>
                      <Avatar
                        sx={{
                          bgcolor: colorEvents(event.lvl),
                        }}
                      >
                        {iconsEvents(event.lvl)}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography
                          variant="body1"
                          sx={{
                            whiteSpace: 'normal',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {event.message}
                        </Typography>
                      }
                      secondary={
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Typography
                            variant="body2"
                            color="textDisabled"
                            sx={{
                              fontStyle: 'italic',
                              fontWeight: 'normal',
                            }}
                          >
                            {new Date(
                              parseInt(event?.timestamp.$date.$numberLong)
                            ).toLocaleString(intl.locale, {
                              year: 'numeric',
                              month: 'short',
                              day: '2-digit',
                              hour: '2-digit',
                              minute: '2-digit',
                              second: '2-digit',
                            })}
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              color: colorEvents(event.lvl),
                            }}
                          >
                            {alert_prior[parseInt(event?.lvl) - 1]}
                          </Typography>
                        </Box>
                      }
                    />
                  </MenuItem>
                ))}
              </List>
            )}
            <Divider />
            {events.length > 5 && (
              <MenuItem>
                <Button
                  variant="contained"
                  onClick={handleShowMore}
                  size="small"
                  fullWidth={true}
                  color="secondary"
                >
                  {showMore < events.length ? 'Ver más' : 'Ver menos'}
                </Button>
              </MenuItem>
            )}
          </Menu>
          {!(
            pathname === user.home_url || pathname === '/dashboard/:corpId'
          ) ? (
            <Button
              className={classes.backButton}
              onClick={() => goBack()}
              variant="contained"
              type="button"
            >
              {intl.formatMessage({ id: 'app.topBar.returnBtn' })}
            </Button>
          ) : (
            ''
          )}
        </Toolbar>
      </div>
    </>
  );
}
